<template>
  <!-- Floating tab pinned to the right edge; only shown to signed-in users while the feature is enabled. -->
  <button
    if.bind="feedback.enabled && account.isAuthenticated && !feedback.open"
    class="feedback-fab"
    click.trigger="feedback.openPopup()"
    aria-label="Send feedback"
    title="Send feedback">
    <span class="icon icon--comment" aria-hidden="true"></span>
  </button>

  <!-- Comment popup. Reuses the shared modal-overlay/login-modal shell. -->
  <div if.bind="feedback.open" class="modal-overlay" click.trigger="feedback.closePopup()">
    <form class="login-modal feedback-modal" submit.trigger="feedback.submit()" click.trigger="$event.stopPropagation()">
      <h3 class="login-modal__title">Send feedback</h3>

      <div if.bind="feedback.submitted" class="feedback-modal__success">
        <span class="icon icon--info" aria-hidden="true"></span>
        <p>Thanks! Your feedback has been sent.</p>
        <div class="login-actions">
          <button type="button" class="login-btn login-btn--primary" click.trigger="feedback.closePopup()">Close</button>
        </div>
      </div>

      <template if.bind="!feedback.submitted">
        <p class="feedback-modal__subtitle">Tell us what you think or report a problem. We read every message.</p>

        <label class="login-field">
          <span>Comment</span>
          <textarea
            value.bind="feedback.comment"
            rows="5"
            maxlength="4000"
            placeholder="Your feedback…"
            disabled.bind="feedback.submitting"></textarea>
        </label>

        <label class="login-field">
          <span>Email (optional)</span>
          <input
            type="email"
            value.bind="feedback.email"
            autocomplete="email"
            placeholder="So we can reply"
            disabled.bind="feedback.submitting" />
        </label>

        <div if.bind="feedback.error" class="login-error">${feedback.error}</div>

        <div class="login-actions">
          <button type="button" class="login-btn login-btn--secondary" click.trigger="feedback.closePopup()" disabled.bind="feedback.submitting">Cancel</button>
          <button type="submit" class="login-btn login-btn--primary" disabled.bind="feedback.submitting || !feedback.comment.trim()">
            ${feedback.submitting ? 'Sending…' : 'Send'}
          </button>
        </div>
      </template>
    </form>
  </div>
</template>
